import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Clipboard from '../../../svg/Clipboard.js';
import Formsy from 'formsy-react';
import FormsyCheckbox from '../../form/FormsyCheckbox';

class Finish extends Component {
  state = {
    client: {
      accepted_terms_and_conditions: false
    },
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const { accepted_terms_and_conditions } = this.state.client;
    const { isCurrentStep } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="You're All Set Once You Accept the Terms Below"
          subline="We look forward to cooking for you."
          icon={<Clipboard />}
        />

        <a
          className="onboarding-new__link"
          href="https://www.theculinistas.com/terms-conditions/"
          target="_blank"
          rel="noopener noreferrer"
        >
          TERMS AND CONDITIONS
        </a>

        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
          className="new-form onboarding-new__form"
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsyCheckbox
                name="accepted_terms_and_conditions"
                className="checkbox--large checkbox--large-blue checkbox--flex checkbox--short checkbox--onboarding"
                placeholder="ACCEPT THE TERMS AND CONDITIONS"
                value={accepted_terms_and_conditions}
                onChange={this.toggleChecked}
                validations="isTrue"
              />
            </div>
          </div>
        </Formsy>

        <div className="onboarding-new__info-box" style={{ "text-align": "left"}}>
          <p className='p p--new-line p--pad-bot'>
            The chef will be cooking everything in your kitchen, so we want to make
            sure it's stocked for the service!
          </p>

          {/* <p className='p p--new-line p--pad-top'> */}
          <p className='p p--new-line'>
              Please make sure you have: a large cutting board, set of mixing bowls, 4-qt
              large stock pot, large saute pan, small saute pan, small saucepan, 2 baking
              sheets, baking dish, colander, strainer, spatula, fish spatula, tongs,
              whisk, can opener, box grater, regular-sized blender/food processor (i.e. 4
              cup or larger).
          </p>
        </div>
      </React.Fragment>
    );
  }

  toggleChecked = e => {
    const { accepted_terms_and_conditions = false } = this.state.client;

    const client = {
      ...this.state.client,
      accepted_terms_and_conditions: !accepted_terms_and_conditions
    };

    // update state and client in parent component
    this.setState(
      {
        client
      },
      this.props.updateClient(client)
    );
  };

  componentDidMount() {
    const { client } = this.props;
    this.setState({ client });
  }

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;

    if (prevProps.client !== client) this.setState({ client });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then submit the new client
      this.props.submitClient();
    }
  }
}

export default Finish;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Finish.js